
import saree1 from "../assets/saree1.avif";
import saree2 from "../assets/saree2.avif";
import saree3 from "../assets/saree3.jpg";
import saree4 from "../assets/saree4.jpg";
import saree5 from "../assets/saree5.avif";

export const products = [
  {
    id: "saree-001",
    name: "Traditional Banarasi Saree",
    category: "Banarasi",
    image: saree1,
    slug: "traditional-banarasi-saree",
  },
  {
    id: "saree-002",
    name: "Pink Party Wear Saree",
    category: "Party Wear",
    image: saree2,
    slug: "pink-party-wear-saree",
  },
  {
    id: "saree-003",
    name: "Floral Printed Saree",
    category: "Printed Saree",
    image: saree3,
    slug: "floral-printed-saree",
  },
  {
    id: "saree-004",
    name: "Designer Wedding Saree",
    category: "Wedding Wear",
    image: saree4,
    slug: "designer-wedding-saree",
  },
  {
    id: "saree-005",
    name: "Classic Silk Saree",
    category: "Silk Saree",
    image: saree5,
    slug: "classic-silk-saree",
  },
];

export default products;
